import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/index_xf.png'
import _imports_2 from '../assets/img/btn_bg.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-792153b6")

_pushScopeId("data-v-792153b6")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1hkb2loct108j1h381avu1hcr18tlt.png",
  class: "title",
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "texts" }, [
  /*#__PURE__*/_createVNode("span", null, "四川省两会你知多少？"),
  /*#__PURE__*/_createVNode("span", null, "今年两会你最关注什么？"),
  /*#__PURE__*/_createVNode("span", null, "你最期待哪些问题得到解决？")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "xf",
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Xiaofeng = _resolveComponent("Xiaofeng")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_Xiaofeng),
    _hoisted_5,
    _createVNode("img", {
      src: _imports_2,
      class: "btn",
      alt: "点击进入",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)))
    })
  ]))
})